import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../core/services/loader/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {

  show = false;
  showLoader = false;
  private subscription: Subscription;
  private subscriptionHeader: Subscription;

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: boolean) => {
        this.show = state;
      });
      this.subscriptionHeader = this.loaderService.loaderheaderState
      .subscribe((state: boolean) => {
        this.showLoader = state;
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionHeader.unsubscribe();
  }

}
